import { defineMessages } from 'react-intl';

export default defineMessages({
    contactAgent: {
        id: 'portal.contact-agent.views.Contact Agent',
        defaultMessage: 'Contact Agent'
    },
    basedOnTheInformation: {
        id: 'portal.contact-agent.views.Based on the information you have provided, we are unable to process your request online.',
        defaultMessage: 'Based on the information you have provided, we are unable to process your request online.'
    },
    callForAssistance: {
        id: 'portal.contact-agent.views.Please call one of our agents at',
        defaultMessage: 'Please call one of our agents at 1-800-231-1363 for assistance with submitting your claim.'
    },
    claimReferenceNumber: {
        id: 'portal.fnol.common.views.contact-agent.Claim reference number',
        defaultMessage: 'Claim reference number {num}'
    },
    back: {
        id: 'portal.contact-agent.views.Back to Claims',
        defaultMessage: 'Back to Claims'
    },
});
